import React from 'react';
import useWidgetActionsBuilder from '../../../../hooks/generic/Actions/useWidgetActionsBuilder';
import ChrWidget from '../../../generic/PageUI/Compound/ChrWidget';
import { getDefaultWidgetConfigs, getRemoteConfigs } from '../utils';
import MatchingOverviewWidgetBody from './body';

/*
props = {
  data: {
    uId: <uniqueIdentifier>,
    name: <string>,
    className: <string>,
    url: <string>
  }
}
*/

const MatchingOverview = (props) => {
  const { name, url, actionsData } = props;
  const defaultWidgetConfigs = getDefaultWidgetConfigs({ ...props, className: "grid-item-span-full-width" });
  const configBuilder = (_state) => {
    return {
      remoteOptions: getRemoteConfigs(url, MatchingOverviewWidgetBody)
    };
  };

  const { actions, widgetConfig } = useWidgetActionsBuilder(actionsData, configBuilder);

  return (
    <ChrWidget
      { ...defaultWidgetConfigs }
      header={ name }
      { ...widgetConfig.remoteOptions }
      footerActions={ actions.footerActions }
    />
  );
};

export default MatchingOverview;